import { ProductDetails } from "../../../../../../../../Wrap/Models/Domains/Account/ProductDetails";
import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../../../react-core/Flux/BaseStore";
import { ProductDetailsDispatcher } from "./Variable";

export interface ProductDetailsStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: ProductDetails;
}

export class ProductDetailsStatic extends BaseStore<ProductDetailsStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(ProductDetailsDispatcher, (actionData) =>
            this.onProductDetailsStoreResponse(actionData)
        );
    }

    public getLastResult(): ProductDetailsStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): ProductDetailsStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onProductDetailsStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: ActionType.Update, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
